[
  {
    "code" : 1,
    "name" : "Allround Marine Service (AMS)"
  },
  {
    "code" : 2,
    "name" : "Anticimex"
  },
  {
    "code" : 3,
    "name" : "Eco Worldwide Solutions (EWS)"
  },
  {
    "code" : 4,
    "name" : "Ruvoma"
  },
  {
    "code" : 5,
    "name" : "Spike International"
  },
  {
    "code" : 6,
    "name" : "Other"
  }
]